import { useState } from "react";
import { Star } from "@mui/icons-material";
import { IconButton, Button, Typography } from "@mui/material";
import { customEvent } from "src/utils/gtag.js";

export const StarsSelect = ({ stars, setStars, calendar }) => {
  const [hoverIndex, setHoverIndex] = useState(-1);

  const handleStarClick = (index) => {
    const rating = index + 1;
    setStars(rating);
    customEvent({
      name: `user_click_star_rating_${rating}`,
      category: "user_feedback",
      label: "calendar_added_successfully",
      value: index + 1,
    });
  };

  const getFeedbackUrl = (rating) => {
    return rating >= 4 
      ? `https://docs.google.com/forms/d/e/1FAIpQLSes0DJj5r2PdIF-MH4uyvqq9esoiDx_bheFwnbjee5P0S8YPw/viewform?usp=pp_url&entry.2130649886=${encodeURIComponent(calendar?.name)}&entry.1110045124=${rating}`
      : `https://docs.google.com/forms/d/e/1FAIpQLSeoR-7PxvR5w6SMcQ8kiUBf6OSxILKM0iphz5KpghxLZWSxRA/viewform?usp=pp_url&entry.2130649886=${rating}`;
  };

  const handleMouseEnter = (index) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(-1);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>How did we do?</Typography>
      <div style={{ display: "flex", gap: 0.5 }}>
        {Array.from({ length: 5 }, (_, index) => (
          <IconButton
            key={index}
            onClick={() => handleStarClick(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            sx={{
              padding: 0,
              color:
                index < (hoverIndex !== -1 ? hoverIndex + 1 : stars)
                  ? "#000000"
                  : "transparent",
              "& svg": {
                stroke: "#000000", // Add black outline
                strokeWidth: .5,    // Set outline width
              },
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Star sx={{ fontSize: "2.5rem" }} />
          </IconButton>
        ))}
      </div>
      {stars > 0 && (
        <Button
          variant="outlined"
          size="shrinked"
          href={getFeedbackUrl(stars)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleStarClick()}
        >
          {stars >= 4 ? "Leave a review" : "Help us improve"}
        </Button>
      )}
    </div>
  );
};
